import React from 'react';

import { useNavigate } from 'react-router-dom';

import { VectorIcon } from 'components/common/Icons/Icons';

import styles from './DocumenPreview.module.scss';

interface DocumentProps {
  title: string;
  handleBack?: (event: any) => void;
}

const DocumentPreview = ({ title, children, handleBack }: React.PropsWithChildren<DocumentProps>) => {
  const navigator = useNavigate();
  const onBack = async (event: any) => {
    if (handleBack) {
      await handleBack(event);
    } else {
      navigator(-1);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerTitle}>
        <VectorIcon className={styles.backButton} onClick={onBack} />
        {title}
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default DocumentPreview;
